import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/global.css';
import './css/inputBox.css';

import AuthProvider from './hooks/index';

import Roote from './routes/Root';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Roote />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
